@if (employees && incidentCodesByGroup) {
	<mat-tab-group [selectedIndex]="noteOnly ? 1 : 0">
		<mat-tab label="{{ 'mes.mes-production-terminal.mes-production-terminal-tab-dialog.stock-reorder.create-title' | translate }}" [disabled]="noteOnly">
			@if (!noteOnly) {
				<app-terminal-create-stock-reorder-dialog [itemOperation]="itemOperation" [employees]="employees" [incidentCodesByGroup]="incidentCodesByGroup" />
			}
		</mat-tab>
		<mat-tab label="{{ 'mes.mes-production-terminal.mes-production-terminal-tab-dialog.production-note.create-title' | translate }}">
			<app-terminal-create-production-note-dialog [itemOperation]="itemOperation" [employees]="employees" />
		</mat-tab>
	</mat-tab-group>
}
